import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import DashboardLayout from "./components/layout/DashboardLayout";
import NewScrape from "./pages/NewScrape";
import ScrapeHistory from "./pages/ScrapeHistory";
import NotFound from "./pages/NotFound";
import Billing from "./pages/Billing";
import Settings from "./pages/Settings/Settings";
import DeveloperApi from "./pages/DeveloperApi";
import UsageTracker from "./pages/UsageTracker";
import SupportWrapper from "./pages/SupportWrapper";
import Login from "./pages/AuthPages/Login";
import Signup from "./pages/AuthPages/Signup";
import ResetPassword from "./pages/AuthPages/ResetPassword";
import OAuthCallback from "./pages/AuthPages/OAuthCallback";
import GoogleCallbackProxy from "./pages/AuthPages/GoogleCallbackProxy";
import { ScrapeProvider } from "./contexts/ScrapeProvider";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AdminLayout from "./components/layout/AdminLayout";
import { AdminOverview } from "./pages/Admin/AdminOverview";
import { UserManagement } from "./pages/Admin/UserManagement";
import AdminUserView from "./pages/Admin/AdminUserView";
import PricingManagement from "./pages/Admin/PricingManagement";
import SessionManager from "./pages/Admin/SessionManager";

export default function App() {
  return (
    <ScrapeProvider>
      <CurrencyProvider>
        <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<OAuthCallback />} />
        <Route path="/api/auth/google/callback" element={<GoogleCallbackProxy />} />
        <Route path="/support" element={<SupportWrapper />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/new" element={<NewScrape />} />
            <Route path="/history" element={<ScrapeHistory />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/developer" element={<DeveloperApi />} />
            <Route path="/usage" element={<UsageTracker />} />
          </Route>
          <Route element={<AdminRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<AdminOverview />} />
              <Route path="/admin/new" element={<NewScrape />} />
              <Route path="/admin/history" element={<ScrapeHistory />} />
              <Route path="/admin/users" element={<UserManagement />} />
              <Route path="/admin/users/:userId/view" element={<AdminUserView />} />
              <Route path="/admin/pricing" element={<PricingManagement />} />
              <Route path="/admin/sessions" element={<SessionManager />} />
              {/* Optional Placeholder for settings */}
              <Route path="/admin/settings" element={<div className="p-8 text-white">Platform settings coming soon</div>} />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      </CurrencyProvider>
    </ScrapeProvider>
  );
}